<template>
  <div class="course_table grey">
    <b-table
      :loading="isLoading"
      default-sort="id"
      pagination-simple
      per-page="15"
      :data="statistic"
      :total="totalCount"
      @page-change="changePage"
      backend-pagination
      paginated>
      <template slot-scope="props">
        <b-table-column
          label="Название курса"
          :visible="true"
          field="course_name"
          :centered="false"
          sortable
          width="20%"
        >
          <div>{{ props.row.course_name }}</div>
        </b-table-column>
        <b-table-column
          label="Название урока"
          :visible="true"
          field="stage_name"
          :centered="false"
          sortable
          width="20%"
        >
          <div>{{ props.row.stage_name }}</div>
        </b-table-column>
        <b-table-column label="Статус" :visible="true" field="status" :centered="false" sortable width="12.5%">
          <div>{{ setStatus(props.row.status) }}</div>
        </b-table-column>
        <b-table-column label="Время" :visible="true" field="time" :centered="false" sortable width="10%">
          <div>{{ !props.row.time || props.row.time === '00:00' ? '--:--' : props.row.time }}</div>
        </b-table-column>
        <b-table-column label="Прогресс (%)" :visible="true" field="result" :centered="false" sortable width="12.5%">
          <div>{{ calcResult(props.row) }}</div>
        </b-table-column>
        <b-table-column
          label="Дата прохождения"
          :visible="true"
          field="created_at"
          :centered="false"
          sortable
          width="20%"
        >
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="" :visible="true" :centered="false" width="5%">
          <div class="text-blue" @click="download(props.row)" title="Скачать протокол">
            <i style="font-size: 16px;" class="mdi mdi-download"></i>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    statistic: {
      default: () => [],
      type: Array
    },
    search: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => false,
      type: Boolean
    },
  },
  methods: {
    download(val) {
      this.$axios
        .post('protocol', {
          commission_id: null,
          user_test_attempt_id: val.id
        })
        .then((resp) => {
          window.open(resp.data.data.protocol_url)
        })
        .catch(this.$errorToast)
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    setStatus(status) {
      switch (status) {
        case 0:
          return 'Не пройден'
        case 1:
          return 'Пройден'
      }
    },
    calcResult(row) {
      const { correct_answers_count: correct, question_count: total } = row;
      return `${correct}/${total}, ${((correct / total) * 100).toFixed(1)}%`;
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
  }
}
</script>
